<template>
  <div class="text-base">
    <label
      class="focus-within:custom-focus-outline relative flex h-6 w-6 items-center justify-center rounded-full px-1 py-1 focus-within:bg-light-grey xl:h-10 xl:w-10 xl:p-2"
    >
      <select
        v-if="options?.length > 0"
        :id="`select-${attrs.name}`"
        :autocomplete="attrs.autocomplete"
        :disabled="disabled"
        :name="attrs.name"
        :required="attrs.required"
        :value="modelValue"
        class="absolute inset-0 opacity-0"
        @input="onInput($event.target.value)"
      >
        <option ref="firstOptionRef" :label="label ?? ' '" disabled selected value="">
          {{ label ?? "" }}
        </option>

        <option
          v-for="{ value, label: optionLabel, disabled: optionDisabled } in options"
          :key="value"
          ref="optionRefs"
          :disabled="optionDisabled"
          :label="optionLabel ?? value"
          :selected="value === modelValue"
          :value="value"
        ></option>
      </select>
      <SvgIcon
        class="pointer-events-none opacity-50 xl:rotate-90"
        name="Options-Horizontal"
      ></SvgIcon>
    </label>
  </div>
</template>

<script setup>
import SvgIcon from "~/templates/elements/SvgIcon.vue";
defineProps(["modelValue", "options", "label", "errorMessage", "disabled"]);
const attrs = useAttrs();
const emit = defineEmits(["update:modelValue"]);

const isDesktopOpen = ref(false);

const onInput = (value) => {
  emit("update:modelValue", value);
  isDesktopOpen.value = false;
};

const firstOptionRef = ref(null);
const optionRefs = ref([]);
const reset = () => {
  optionRefs.value.forEach((option) => {
    option.selected = false;
  });
  firstOptionRef.value.selected = true;
  emit("update:modelValue", "");
};
defineExpose({ reset });
</script>

<style scoped>
select {
  @apply appearance-none;
}
[readonly],
[disabled] {
  @apply cursor-not-allowed opacity-60 grayscale;
}
</style>
